import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {motion} from "framer-motion"

const Page7 = () => {
  const navigate = useNavigate();
  const firstpage = () => {
    navigate("/initial", {
      state: { hexkey, hexuserInput, KeyValue, userInput },
    });
  };
  const second = () => {
    navigate("/page6", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const goToKset = () => {
    navigate("/Kset", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const goToSset = () => {
    navigate("/Sset", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const location = useLocation();
  const userInput = location.state.userInput;
  const KeyValue = location.state.KeyValue;
  const hexuserInput = location.state.hexuserInput;
  const hexkey = location.state.hexkey;

  function splitHexInput(hexuserInput) {
    // Remove leading and trailing whitespaces
    hexuserInput = hexuserInput.trim();

    // Remove any extra whitespaces between hex values
    hexuserInput = hexuserInput.replace(/\s+/g, " ");

    // Split the input string into an array of hexadecimal values
    const hexValues = hexuserInput.split(" ");

    // Create a 2D array with 4 elements in each inner array
    const result = [];
    for (let i = 0; i < hexValues.length; i += 4) {
      result.push(hexValues.slice(i, i + 4));
    }

    return result;
  }

  const splitIp = splitHexInput(hexuserInput);
  console.log(splitIp);

  const splitKey = splitHexInput(hexkey);
  console.log(splitKey);

  function xorArrays(array1, array2) {
    // Ensure both input arrays have the same length
    if (array1.length !== array2.length) {
      throw new Error("Input arrays must have the same length");
    }

    // Perform XOR operation on corresponding elements
    const resultArray = [];
    for (let i = 0; i < array1.length; i++) {
      const xorResult = [];
      for (let j = 0; j < array1[i].length; j++) {
        const element1 = parseInt(array1[i][j], 16);
        const element2 = parseInt(array2[i][j], 16);
        const xorValue = element1 ^ element2;
        xorResult.push(xorValue.toString(16).padStart(2, "0"));
      }
      resultArray.push(xorResult);
    }

    return resultArray;
  }

  const resultXOR = xorArrays(splitIp, splitKey);
  console.log(resultXOR);

  const ArrayVisualizer = ({ array, containerId }) => {
    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "repeat(16, minmax(0, 1fr))",
      gap: "1rem",
      marginTop: "1rem",
    };

    // Define a list of colors
    const colors = [
      "bg-blue-200",
      "bg-green-200",
      "bg-yellow-200",
      "bg-pink-200",
    ];

    return (
      <div id={containerId} style={gridStyle}>
        {array.map((innerArray, rowIndex) =>
          innerArray.map((element, colIndex) => {
            const colorIndex =
              Math.floor((rowIndex * array[0].length + colIndex) / 4) %
              colors.length;

            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                className={`border border-solid p-4 text-center w-16 h-16 ${
                  colors[colorIndex] // Apply color based on every 4 elements
                }`}
              >
                {element}
              </div>
            );
          })
        )}
      </div>
    );
  };

  const addSpaceBetweenChars = (value) => {
    if (typeof value === 'string') {
      return value.match(/.{1,2}/g).join(' ');
    } else {
        return String(value).split('').join('');
    }
  };



  return (
    <>
    <div>
    <div className="mx-auto align-middle justify-cente text-center">
        <h1 className=" font-semibold text-3xl pb-5">Inside Key Schedule.</h1>
        <p>
          There are two sets of subkeys generated from the orginal sub key K set and S set.
          <br/> K set includes 32 words for each rounds(2 wordes for 16 rounds) and 8 words for input whitening and output whitening.
          <br/> S set includes 2 subkeys S0 and S1 which remanins constant forthe whole decryption and decryption process.
        </p>
      </div>
    <div className="ml-10 mr-10">     
    <ArrayVisualizer array={splitKey} containerId="splitKey" />
    
    </div>  

    <div className="pl-40">
      <svg xmlns="http://www.w3.org/2000/svg" width="1092" height="281" fill="none" viewBox="0 0 1092 281">
        <path fill="#fff" d="M0 0h1092v281H0z"/>
        <path stroke="#000" stroke-width="3" d="M58 139.5h976M547.5 27v114m-488 0v114m976-117v114"/>
      </svg>
    </div>

    <div className="grid grid-cols-2"> 
      <div className="h-40 w-60 bg-blue-200 ml-24 ">
        <p className="mt-16 ml-24">K set</p>
        <button
        onClick={goToKset}
          className="bg-white text-blue-500 px-4 py-2 mt-2 rounded hover:bg-green-200 hover:text-green-700 transition duration-300 ml-20">
            View
        </button>
      </div>

      <div className="h-40 w-60 bg-pink-200 ml-80">
      <p className="mt-16 ml-24">S set</p>
      <button
          onClick={goToSset}
          className="bg-white text-blue-500 px-4 py-2 mt-2 rounded hover:bg-green-200 hover:text-green-700 transition duration-300 ml-20">
          View
      </button>
      </div>

    </div>

    </div>
    <div class="button-holder">
    <div class="prev-button" onClick={firstpage}>
      PREVIOUS
    </div>
    <div class="next-button" onClick={second}>
      NEXT
    </div>
  </div>
  </>
  );
};

export default Page7;
